import React from "react";

function CareerSummary() {
  return (
    <div>
      <p>
        Senior Technology Leader with extensive experience driving digital
        transformations, implementing strategic initiatives, and leading
        cross-functional teams to deliver measurable business outcomes. Proven
        track record aligning technology and data solutions with overarching
        business goals, reducing operational risks, and achieving sustainable
        growth. Adept in vendor management, cloud infrastructure, DevOps
        practices, and data-driven decision-making.
      </p>
    </div>
  );
}

export default CareerSummary;
